import styled from "styled-components";
import { useState, useEffect } from "react";
import FormDatePicker from "../../../../../../components/FormControls/FormDatePicker";
import PrimaryButton from "../../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../../components/FormControls/SecondaryButton";
import WarningButton from "../../../../../../components/FormControls/WarningButton";
import request from "../../../../../../api/request";
import MessageBox from "../../../../../../components/MessageBox";
import NarrowGrid from "../../../../../../components/NarrowGrid";
import { NotificationManager } from 'react-notifications';
import FormSelectWithLabel from "../../../../../../components/FormControls/FormSelectWithLabel";
import FormStringInput from "../../../../../../components/FormControls/FormStringInput";
import FormNumberInput from "../../../../../../components/FormControls/FormNumberInput";
import FormCheckBox from "../../../../../../components/FormControls/FormCheckBox";

const StyledBranchBankAccountSettings = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 600px;
    box-sizing: border-box;
    min-height: 543px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function BranchBankAccountSettings(props) {

    let currentYear = new Date().getFullYear();

    let years = [];
    for (let i = currentYear - 10; i < currentYear + 5; i ++) {
        years.push(i);
    }

    const {selectedBranch, isAddBranchMode, setIsAddBranchMode, refreshBranchesCallback} = props;

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeletingBranch, setIsDeletingBranch] = useState(false);
    const [isDeletingBankAccount, setIsDeletingBankAccount] = useState(false);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [selectedBankAccount, setSelectedBankAccount] = useState(null);
    const [selectedBankAccountId, setSelectedBankAccountId] = useState(null);
    const [isAddBankAccountMode, setIsAddBankAccountMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Name', type: 'String', width: 150, textAlign: 'left'},
        {id: 'Code', type: 'String', width: 70, textAlign: 'center'},
    ]);
    const [gridData, setGridData] = useState({groups: [''], items: [[]]});

    const [bankCode, setBankCode] = useState('');
    const [dateAuthorisedbyChairman, setDateAuthorisedbyChairman] = useState(null);
    const [bankName, setBankName] = useState('');
    const [openingBalance, setOpeningBalance] = useState('0.00');
    const [accountType, setAccountType] = useState(1);
    const [canExport, setCanExport] = useState(false);
    const [earmarkedFundCode, setEarmarkedFundCode] = useState(null);
    const [festivalBankAccount, setFestivalBankAccount] = useState(false);
    const [accountName, setAccountName] = useState(null);
    const [accountCategoryCode, setAccountCategoryCode] = useState('001');
    const [accountNumber, setAccountNumber] = useState('');
    const [sortCode, setSortCode] = useState('');

    const [showMessageBox, setShowMessageBox] = useState(false);
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isAddingDuplicatedBankAccount, setIsAddingDuplicatedBankAccount] = useState(false);

    const [festivalList, setFestivalList] = useState([]);

    let accountTypes = ['Bank account', 'Cash account'];
    const accountTypeStringToInt = (accountTypeStr) => {
        if (accountTypeStr === 'Bank account') {
            return 1;
        } else {
            return 2;
        }
    }
    
    const convertDateToUTCTimeZone = (val) => {
        let diffMinutes = val.getTimezoneOffset();
        val.setTime(val.getTime() - diffMinutes*60*1000);
        return val;
    }
    
    const onChangeAccountType = (e) => {
        let aType = accountTypeStringToInt(e.target.value);
        setAccountType(aType);
    }

    let accountCategories = ['Current account', 'Deposit account'];
    const accountCategoryStringToInt = (accountCategoryStr) => {
        if (accountCategoryStr === 'Current account') {
            return '001';
        } else {
            return '002';
        }
    }
    const onChangeAccountCategory = (e) => {
        let aCategory = accountCategoryStringToInt(e.target.value);
        setAccountCategoryCode(aCategory);
    }

    const onSelectGridItem = (item) => {
        setSelectedBankAccountId(item.Id);
        setSelectedBankAccount(item);
    }
    
    const fetchBankAccounts = async (branchCommitteeCodeToSelect, bankCode) => {
        try {
            let bankAccountList = [];

            const resp = (await request('database', 'fetchBankAccounts'));
            if (resp.ok) {
                resp.data.map((bankAccount, index) => {
                    bankAccountList.push(bankAccount);
                });
                setBankAccounts(bankAccountList);
                rebuildGridData(bankAccountList, branchCommitteeCodeToSelect, bankCode);
            } else {
                console.log('Failed fetchBankAccounts');
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch bank accounts: ', e);
            return false;
        }
        return true;
    }

    const fetchFestivals = async () => {
        if (selectedBranch) {
            try {
                let festivals = [];
                let resp = (await request('database', 'fetchFestivals'));
                if (resp.ok) {
                    resp.data.map((festival) => {
                        if (festival.RecordType === selectedBranch.RecordType && festival.BranchCommitteeCode === selectedBranch.BranchCommitteeCode && festival.DivisionCode === selectedBranch.DivisionCode) {
                            festivals.push(festival);
                        }
                    });
                    setFestivalList(festivals);
                } else {
                    console.log('Failed fetchFestivals');
                    NotificationManager.error(resp.data);
                }
            } catch (e) {
                console.log('Failed to fetch festivals: ', e);
            }
        }
    }

    const onDeleteBankAccount = async () => {
        if (selectedBankAccount) {
            setIsDeletingBankAccount(true);
            let deleteData = {};
            deleteData.RecordType = selectedBranch.RecordType;
            deleteData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
            deleteData.DivisionCode = selectedBranch.DivisionCode;
            deleteData.BankCode = bankCode;

            const resp = (await request('database', 'deleteBranchBankAccount', [deleteData]));
            if (resp.ok) {
                setSelectedBankAccount(null);
                setSelectedBankAccountId(null);
                fetchBankAccounts(selectedBranch.BranchCommitteeCode, selectedBankAccount ? selectedBankAccount.BankCode : null);
                NotificationManager.success('Successfully deleted bank account');
            } else
            {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeletingBankAccount(false);
        }
    }

    const onSaveChanges = async () => {
        if (isAddBankAccountMode) { // adding new item
            if (bankCode === '' || dateAuthorisedbyChairman === null || bankName === '') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (gridData.items[0].length > 0 && (gridData.items[0].find((itm) => itm.BankCode.replace(/\s/g, '') === bankCode.toString()))) {
                    setIsAddingDuplicatedBankAccount(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = selectedBranch.RecordType;
                    saveData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
                    saveData.DivisionCode = selectedBranch.DivisionCode;
                    saveData.BankCode = bankCode;
                    saveData.DateAuthorisedbyChairman = convertDateToUTCTimeZone(dateAuthorisedbyChairman);
                    saveData.BankName = bankName;
                    saveData.OpeningBalance = openingBalance;
                    saveData.AccountType = accountType;
                    saveData.CanExport = canExport;
                    saveData.EarmarkedFundCode = earmarkedFundCode;
                    saveData.FestivalBankAccount = festivalBankAccount;
                    saveData.AccountName = accountType === 1 ? accountName : null;
                    saveData.AccountCategoryCode = accountType === 1 ? accountCategoryCode : null;
                    saveData.AccountNumber = accountType === 1 ? accountNumber : '00000000';
                    saveData.SortCode = accountType === 1 ? sortCode : '000000';

                    const resp = (await request('database', 'addBranchBankAccount', [saveData]));
                    if (resp.ok) {
                        fetchBankAccounts(selectedBranch.BranchCommitteeCode, bankCode);
                        NotificationManager.success('Successfully added bank account');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddBankAccountMode(false);
                }
            }
        } else {
            if (bankCode === '' || dateAuthorisedbyChairman === null || bankName === '') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                setIsSaving(true);
                let saveData = {};
                saveData.RecordType = selectedBranch.RecordType;
                saveData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
                saveData.DivisionCode = selectedBranch.DivisionCode;
                saveData.BankCode = bankCode;
                saveData.DateAuthorisedbyChairman = convertDateToUTCTimeZone(dateAuthorisedbyChairman);
                saveData.BankName = bankName;
                saveData.OpeningBalance = openingBalance;
                saveData.AccountType = accountType;
                saveData.CanExport = canExport;
                saveData.EarmarkedFundCode = earmarkedFundCode;
                saveData.FestivalBankAccount = festivalBankAccount;
                saveData.AccountName = accountName;
                saveData.AccountCategoryCode = accountCategoryCode;
                saveData.AccountNumber = accountNumber;
                saveData.SortCode = sortCode;

                const resp = (await request('database', 'updateBranchBankAccount', [saveData]));
                if (resp.ok) {
                    fetchBankAccounts(selectedBranch.BranchCommitteeCode, selectedBankAccount ? selectedBankAccount.BankCode : null);
                    NotificationManager.success('Successfully updated bank account');
                } else
                {
                    console.log(resp.data);
                    NotificationManager.error(resp.data);
                }
                setIsSaving(false);
            }
        }
    }

    const deleteBranch = async () => {
        setShowMessageBox(false);

        setIsDeletingBranch(true);
        let deleteData = {};
        deleteData.RecordType = selectedBranch.RecordType;
        deleteData.RecordName = selectedBranch.RecordName;
        deleteData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
        const resp = (await request('database', 'deleteBranch', [deleteData]));
        if (resp.ok && refreshBranchesCallback) {
            refreshBranchesCallback();
            NotificationManager.success('Branch deleted');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDeletingBranch(false);
    }

    const onChangeDateAuthorisedByChairman = (val) => {
        setDateAuthorisedbyChairman(val);
    }

    const dateToStr = (date) => {
        function pad(s) { return (s < 10) ? '0' + s : s; };
        let ret = [pad(date.getDate()), pad(date.getMonth()+1), date.getFullYear()].join('/');
        return ret;
    }

    const strToDate = (str) => {
        var date_components = str.split("/");
        var day = date_components[0];
        var month = date_components[1];
        var year = date_components[2];
        return new Date(year, month - 1, day);
    }

    const festivalCodeToFestivalName = (fCode) => {
        if (!fCode) return 'None';

        let f = festivalList.find((e) => e.RestrictedFundCode === fCode);
        if (f) return f.RestrictedFundName;
        else return 'None';
    }

    const festivalNameToFestivalCode = (fName) => {
        let f = festivalList.find((e) => e.RestrictedFundName === fName);
        if (f) return f.RestrictedFundCode;
        else return null;
    }

    const rebuildGridData = (bankAccounts, branchCommitteeCodeToSelect, bankCodeToSelect) => {
        if (bankAccounts && selectedBranch && bankAccounts.length > 0) {
            let bankAccountList = [];
            bankAccounts.map((bankAccount, index) => {
                if (bankAccount.RecordType === selectedBranch.RecordType && bankAccount.BranchCommitteeCode === selectedBranch.BranchCommitteeCode && bankAccount.DivisionCode === selectedBranch.DivisionCode) {
                    let gridItem = {Id: index, Name: bankAccount.BankName, Code: bankAccount.BankCode, Date: dateToStr(new Date(bankAccount.DateAuthorisedbyChairman)), ...bankAccount};
                    bankAccountList.push(gridItem);
                    if (branchCommitteeCodeToSelect && bankCodeToSelect && bankAccount.BranchCommitteeCode === branchCommitteeCodeToSelect && bankAccount.BankCode === bankCodeToSelect) {
                        setSelectedBankAccountId(index);
                        setSelectedBankAccount(gridItem);
                    }
                }
            });
            setGridData({groups: [''], items: [bankAccountList]});
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchBankAccounts();
            setLoadedPage(true);
        }
        fetchFestivals();

        rebuildGridData(bankAccounts);
        setSelectedBankAccount(null);
        setSelectedBankAccountId(null);
        setBankCode('');
        setDateAuthorisedbyChairman(null);
        setBankName('');
        setOpeningBalance('0.00');
        setAccountType(1);
        setCanExport(false);
        setEarmarkedFundCode(null);
        setFestivalBankAccount(false);
        setAccountName(null);
        setAccountCategoryCode('001');
        setAccountNumber('');
        setSortCode('');
        setNeedsValidation(false);
    }, [selectedBranch]);

    useEffect(() => {
        if (isAddBankAccountMode) {
            setNeedsValidation(false);
            setBankCode('');
            setDateAuthorisedbyChairman(null);
            setBankName('');
            setOpeningBalance('0.00');
            setAccountType(1);
            setCanExport(false);
            setEarmarkedFundCode(null);
            setFestivalBankAccount(false);
            setAccountName(null);
            setAccountCategoryCode('001');
            setAccountNumber('');
            setSortCode('');
        } else if (selectedBankAccount) {
            setNeedsValidation(false);
            setBankCode(selectedBankAccount.BankCode);
            setDateAuthorisedbyChairman(selectedBankAccount.Date ? strToDate(selectedBankAccount.Date) : null);
            setBankName(selectedBankAccount.BankName);
            setOpeningBalance(selectedBankAccount.OpeningBalance);
            setAccountType(selectedBankAccount.AccountType);
            setCanExport(selectedBankAccount.CanExport);
            setEarmarkedFundCode(selectedBankAccount.EarmarkedFundCode);
            setFestivalBankAccount(selectedBankAccount.FestivalBankAccount);
            setAccountName(selectedBankAccount.AccountName);
            setAccountCategoryCode(selectedBankAccount.AccountCategoryCode);
            setAccountNumber(selectedBankAccount.AccountNumber);
            setSortCode(selectedBankAccount.SortCode);
        }
    }, [isAddBankAccountMode]);

    useEffect(() => {
        if (selectedBankAccount) {
            setBankCode(selectedBankAccount.BankCode);
            setDateAuthorisedbyChairman(selectedBankAccount.Date ? strToDate(selectedBankAccount.Date) : null);
            setBankName(selectedBankAccount.BankName);
            setOpeningBalance(selectedBankAccount.OpeningBalance);
            setAccountType(selectedBankAccount.AccountType);
            setCanExport(selectedBankAccount.CanExport);
            setEarmarkedFundCode(selectedBankAccount.EarmarkedFundCode);
            setFestivalBankAccount(selectedBankAccount.FestivalBankAccount);
            setAccountName(selectedBankAccount.AccountName);
            setAccountCategoryCode(selectedBankAccount.AccountCategoryCode);
            setAccountNumber(selectedBankAccount.AccountNumber);
            setSortCode(selectedBankAccount.SortCode);
        } else {
            setBankCode('');
            setDateAuthorisedbyChairman(null);
            setBankName('');
            setOpeningBalance('0.00');
            setAccountType(1);
            setCanExport(false);
            setEarmarkedFundCode(null);
            setFestivalBankAccount(false);
            setAccountName(null);
            setAccountCategoryCode('001');
            setAccountNumber('');
            setSortCode('');
        }
    }, [selectedBankAccount]);

    useEffect(() => {
        setIsAddingDuplicatedBankAccount(false);
        setNeedsValidation(false);
    }, [selectedBranch, selectedBankAccount, isAddBankAccountMode, bankCode]);

    return (
        <StyledBranchBankAccountSettings>
            <WhiteBoard>
                <Title>Bank Accounts</Title>
                <div style={{display:'flex'}}>
                    <div>
                        <NarrowGrid id='branchsetting_bankaccounts_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddBankAccountMode} itemIdToSelect={selectedBankAccountId} onSelectGridItem={onSelectGridItem} gridStyle={{width:220, height:350, marginTop:20}}></NarrowGrid>
                        <div style={{marginTop:20}}>
                            {selectedBankAccountId !== null && !isAddBankAccountMode && <SecondaryButton caption='Delete' isLoading={isDeletingBankAccount} onClick={() => onDeleteBankAccount()} style={{width:75, height:25}}></SecondaryButton>}
                            {isAddBankAccountMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddBankAccountMode(false)} style={{width:75, height:25, float:'right'}}></SecondaryButton>}
                            {!isAddBankAccountMode && <PrimaryButton caption='Create new' onClick={() => setIsAddBankAccountMode(true)} style={{width:100, height:25, float:'right'}}></PrimaryButton>}
                        </div>
                    </div>
                    <div style={{marginLeft:30}}>
                        <div style={{display:'flex'}}>
                            <FormStringInput label='Code' value={bankCode} disabled={!isAddBankAccountMode || (selectedBankAccount && selectedBankAccount.IsExported)} validated={needsValidation && bankCode === '' ? false : undefined} onChange={(val) => setBankCode(val)} inputStyle={{width:65}}></FormStringInput>
                            <FormDatePicker label='Date authorised by chairman' value={dateAuthorisedbyChairman} onChange={(val) => onChangeDateAuthorisedByChairman(val)} style={{width:200, paddingLeft:15}} validated={needsValidation && dateAuthorisedbyChairman === null ? false : undefined} disabled={selectedBankAccountId === null && !isAddBankAccountMode} ></FormDatePicker>
                        </div>
                        {isAddingDuplicatedBankAccount && <div style={{marginTop:5, width:280, fontSize:12, fontWeight:700, color:'#dc3545'}}>* Bank code is duplicated.</div>}
                        <FormStringInput label='Bank account name' value={bankName} disabled={!isAddBankAccountMode || (selectedBankAccount && selectedBankAccount.IsExported)} validated={needsValidation && bankName === '' ? false : undefined} onChange={(val) => setBankName(val)} inputStyle={{width:280}}></FormStringInput>
                        <FormStringInput label='Opening statement balance' value={openingBalance} disabled={!isAddBankAccountMode || (selectedBankAccount && selectedBankAccount.IsExported)} validated={needsValidation && openingBalance === '' ? false : undefined} onChange={(val) => setOpeningBalance(val)} inputStyle={{width:280}}></FormStringInput>
                        <FormSelectWithLabel label='Account type' items={accountTypes} value={accountTypes[accountType-1]} disabled={(selectedBankAccountId === null && !isAddBankAccountMode) || (selectedBankAccount && selectedBankAccount.IsExported)} onChange={(e) => onChangeAccountType(e)} style={{width:280, height:35, paddingLeft:13}}></FormSelectWithLabel>
                        <FormCheckBox label='Export to SkyEnterprise' checked={canExport} disabled={(selectedBankAccountId === null && !isAddBankAccountMode) || (selectedBankAccount && selectedBankAccount.IsExported)} onCheck={(val) => setCanExport(val)} style={{paddingTop:5}}></FormCheckBox>
                        
                        <div style={{paddingTop:15}}>
                        {<FormSelectWithLabel
                            label='Festival'
                            items={['None', ...festivalList.map((e) => e.RestrictedFundName)]}
                            value={festivalCodeToFestivalName(earmarkedFundCode)}
                            disabled={(selectedBankAccountId === null && !isAddBankAccountMode) || (selectedBankAccount && selectedBankAccount.IsExported)}
                            onChange={(e) => setEarmarkedFundCode(festivalNameToFestivalCode(e.target.value))}
                            style={{width:280, height:35, paddingLeft:13}}>
                        </FormSelectWithLabel>}
                        <FormCheckBox label='Festival account' checked={festivalBankAccount} disabled={(selectedBankAccountId === null && !isAddBankAccountMode) || (selectedBankAccount && selectedBankAccount.IsExported)} onCheck={(val) => setFestivalBankAccount(val)} style={{paddingTop:5}}></FormCheckBox>

                        {accountType === 1 && <>
                        <div style={{display:'flex'}}>
                            <FormStringInput label='Bank name' value={accountName ? accountName : ''} disabled={selectedBankAccountId === null && !isAddBankAccountMode} onChange={(val) => setAccountName(val)} inputStyle={{width:135}}></FormStringInput>
                            <FormSelectWithLabel label='Category' items={accountCategories} value={accountCategories[parseInt(accountCategoryCode)-1]} disabled={selectedBankAccountId === null && !isAddBankAccountMode} onChange={(e) => onChangeAccountCategory(e)} style={{width:135, height:35, paddingLeft:13, marginLeft:10}} labelStyle={{marginLeft:10}}></FormSelectWithLabel>
                        </div>
                        <div style={{display:'flex'}}>
                            <FormStringInput label='Account number' value={accountNumber ? accountNumber : ''} disabled={selectedBankAccountId === null && !isAddBankAccountMode} onChange={(val) => setAccountNumber(val)} inputStyle={{width:135}}></FormStringInput>
                            <FormStringInput label='Sort code' value={sortCode ? sortCode : ''} disabled={selectedBankAccountId === null && !isAddBankAccountMode} onChange={(val) => setSortCode(val)} inputStyle={{width:135}} style={{paddingLeft:10}}></FormStringInput>
                        </div>
                        </> }
                        </div>
                    </div>
                </div>
            </WhiteBoard>
            <div>
                {!isAddBranchMode && <WarningButton caption='Delete branch' isLoading={isDeletingBranch} onClick={() => setShowMessageBox(true)} style={{width:120}}></WarningButton>}
                {isAddBranchMode && <SecondaryButton caption='Cancel' onClick={() => setShowMessageBox(true)} style={{width:100}}></SecondaryButton>}
                <PrimaryButton caption={isAddBankAccountMode ? 'Add financial year' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddBankAccountMode || selectedBankAccount ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>

            { showMessageBox && <MessageBox
                text = {isAddBranchMode ? 'Are you sure cancel?' : 'Are you sure you want to delete this branch?'}
                yesText = {isAddBranchMode ? 'Cancel' : 'Delete branch'}
                noText = {isAddBranchMode ? 'No' : 'Cancel'}
                isWarning = {!isAddBranchMode}
                handleClickYes = {() => {
                        if (isAddBranchMode) {
                            if (setIsAddBranchMode) {
                                setIsAddBranchMode(false);
                                setShowMessageBox(false);
                            }
                        } else {
                            deleteBranch();
                        }
                    }
                }
                handleClickNo = {() => setShowMessageBox(false)}
            />}
        </StyledBranchBankAccountSettings>
    )
}

export default BranchBankAccountSettings;